<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="CalendarpatternModalLabel">Add</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal needs-validation" novalidate id="formAddCalendarpattern">
        <div class="row">
          <div class="col-lg-12 col-xlg-12 col-md-12 mb-3">
            <label>Name</label>
            <div class="col-md-12">
              <input type="text" class="form-control" v-model="name" required />
              <div class="invalid-feedback">
                Please enter name.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-xlg-12 col-md-12 mb-3">
            <label>Color</label>
            <sketch-picker v-model="bg" style="width: 100%;" />
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary btn-fix" data-bs-dismiss="modal" id="calendarpatternModalclose">
        <i class="fa fa-times"></i> Close
      </button>
      <button type="button" class="btn btn-info btn-fix" @click="checkForm" id="submitbtn"><i class="fas fa-save"></i> Save</button>
    </div>
  </div>
</template>
<style scoped>
.vc-sketch {
  width: auto !important;
}
</style>
<script>
// import api from '../../models/calendarpattern'
import { Sketch } from 'vue-color'

export default {
  props: ['loadNewcalendarpattern'],
  components: {
    'sketch-picker': Sketch
  },
  data() {
    return {
      name: '',
      bg: '#2ECC71'
    }
  },
  methods: {
    checkForm() {
      if (this.name !== '') {
        this.insertCalendarpattern()
      } else {
        $('#formAddCalendarpattern').addClass('was-validated')
      }
    },
    insertCalendarpattern() {
      $('.preloader').fadeIn()
      let formData = {
        name: this.name,
        bg: this.bg.hex === undefined ? '#2ECC71' : this.bg.hex
      }
      api.addCalendarpattern(
        this.$store.state.URLHost,
        formData,
        this.header,
        result => {
          if (result.response === true) {
            this.loadNewcalendarpattern()
            this.alert_msg('success', 'Successful', result.message)
            $('.preloader').fadeOut()
            $('#CalendarpatternModal').modal('hide')
          } else {
            this.loadNewcalendarpattern()
            this.alert_msg('warning', 'An error occurred.', result.message)
            $('.preloader').fadeOut()
            $('#CalendarpatternModal').modal('hide')
          }
        },
        error => {
          this.loadNewcalendarpattern()
          this.alert_msg('error', 'An error occurred.', error.message)
          $('.preloader').fadeOut()
          $('#CalendarpatternModal').modal('hide')
        }
      )
    }
  },
  mounted() {
    var myModalEl = document.getElementById('CalendarpatternModal')
    myModalEl.addEventListener('shown.bs.modal', event => {
      this.name = ''
      $('#formAddCalendarpattern').removeClass('was-validated')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/calendarpattern_add_modal.vue